import { getFirestore, collection, onSnapshot } from "firebase/firestore";
import app from "./firebase";
import { addNotification } from "./notificationStore";

const db = getFirestore(app);

// This function listens for real-time Firestore updates
export function listenToNotifications(callback) {
 
  const notificationsRef = collection(db, "notifications");
   console.log("👂 Listening to Firestore notifications...");

  // Ask permission for desktop notifications
  if (Notification.permission !== "granted") {
    Notification.requestPermission();
  }

  let lastCheck = Date.now();

  // Start listening to Firestore
  const unsubscribe = onSnapshot(notificationsRef, (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      if (change.type === "added") {
        const data = change.doc.data();
        const createdAt = data.createdAt?.toMillis?.() || Date.now();

        // Show system desktop notification
        if (createdAt > lastCheck && Notification.permission === "granted") {
          new Notification(data.title || "New Notification", {
            body: data.message || "You have a new update!",
            icon: "/icon.png",
          });
        }

        console.log("🆕 Firestore notification:", data);

        // ✅ Send the new notification back to React
        if (callback) {
          callback({
            title: data.title || "New Notification",
            desc: data.message || "You have a new update!",
            time: new Date(createdAt).toLocaleTimeString(),
          });
        }

        // Save to local store for Header modal
        addNotification({
          title: data.title || "New Notification",
          desc: data.message || "You have a new update!",
          time: new Date(createdAt).toLocaleTimeString(),
        });
      }
    });

    lastCheck = Date.now();
  });

  return unsubscribe; // Allow cleanup when component unmounts
}
